import { Component, ViewChild, ElementRef, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Component used to bypass Angular security and render script tags
 * @see https://stackoverflow.com/a/44904601
 */
@Component({
  selector: 'customer-script',
  templateUrl: 'customer-script.component.html',
})
export class CustomerScriptComponent {

  @ViewChild('script') script: ElementRef;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      // Create our references
      const element = this.script.nativeElement;
      const script = document.createElement('script');
      script.type = 'text/javascript';

      // Setup the source of the script
      if (element.innerHTML) {
        script.innerHTML = element.innerHTML;
      }

      // Replace the parent element
      const parent = element.parentElement;
      parent.parentElement.replaceChild(script, parent);
    }
  }
}
